import { useContext } from "react";

import { OrganizationWebhooksContext } from "../context/OrganizationWebhooksContext";
import type { OrganizationWebhookConfigData } from "./useOrganizationWebhookConfig";

/** The shared endpoint state. Must be used under `<OrganizationWebhooksProvider>`. */
export function useOrganizationWebhooksData(): OrganizationWebhookConfigData {
  const value = useContext(OrganizationWebhooksContext);
  if (value === null) {
    throw new Error("useOrganizationWebhooksData must be used within an <OrganizationWebhooksProvider>");
  }
  return value;
}
